import React from 'react'

import { AppRoutes, LayoutType, type RouteConfig } from '../routes.types'

// Employee-specific components
const LazyEmployeeBrag = React.lazy(() =>
    import('../../pages/employee/Brag').then((module) => ({ default: module.BragPage })),
)
const LazyEmployeeCareer = React.lazy(() =>
    import('../../pages/employee/Career').then((module) => ({ default: module.CareerPage })),
)

// Document Upload components (renamed from employee-uploads)
const LazyDocumentDataManagementPage = React.lazy(() =>
    import('../../pages/employee/Uploads/upload').then((module) => ({ default: module.DataManagementPage })),
)

export const employeeRoutes: RouteConfig[] = [
    {
        path: AppRoutes.CAREER,
        component: LazyEmployeeCareer,
        layout: LayoutType.APP,
        requireAuth: true,
        requireOrganization: true,
        title: 'Career',
        description: 'Career development and growth opportunities',
        requiredPermission: {
            action: 'view.self', // Matches employee.view.self permission
            subject: 'Employee',
        },
    },
    {
        path: AppRoutes.BRAG,
        component: LazyEmployeeBrag,
        layout: LayoutType.APP,
        requireAuth: true,
        requireOrganization: true,
        title: 'Brag',
        description: 'Share achievements and accomplishments',
        requiredPermission: {
            action: 'edit.self', // Matches employee.edit.self permission for sharing achievements
            subject: 'Employee',
        },
    },
    // Document Upload routes (unified structure)
    {
        path: AppRoutes.UPLOAD_DOCUMENT,
        component: LazyDocumentDataManagementPage,
        layout: LayoutType.APP,
        requireAuth: true,
        requireOrganization: true,
        title: 'Document Upload',
        description: 'Upload and manage documents and files',
        requiredPermission: {
            action: 'manage.documents', // Matches employee.manage.documents permission
            subject: 'Employee',
        },
    },
]
